import { useState } from "react";

import { probeTerminology } from "@/api/terminology";
import type { TerminologyProbeResponse } from "@/api/terminology";
import { useToast } from "@/components/toast";

export function ProbePanel() {
  const { toast } = useToast();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState<TerminologyProbeResponse | null>(null);

  async function run() {
    if (!text.trim()) return;
    setBusy(true);
    setRes(null);
    try {
      // Направление определяем по скрипту ввода: кириллица → RU→EN, иначе EN→RU.
      // Раньше было жёстко EN→RU, из-за чего русские аббревиатуры (МАЖБП, ПОАК)
      // в этой панели не матчились, хотя в словаре они есть (resolver строит их
      // surface только в направлении RU→EN).
      const isCyrillic = /[А-Яа-яЁё]/.test(text);
      const r = await probeTerminology({
        text: text.trim(),
        source_lang: isCyrillic ? "ru" : "en",
        target_lang: isCyrillic ? "en" : "ru",
        include_translation: true,
      });
      if (r.ok) setRes(r.data);
      else toast(r.error || "Проба не удалась", "error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <textarea
        className="mt-input"
        rows={3}
        style={{ width: "100%", fontSize: "var(--fs-sm)" }}
        placeholder="Вставь фразу (RU или EN) — увидишь, какие термины сработают и как переведётся"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <div style={{ marginTop: 6 }}>
        <button
          type="button"
          className="mt-btn mt-btn--sm mt-btn--secondary"
          disabled={busy}
          onClick={() => void run()}
        >
          {busy ? "Проверяю…" : "Проверить"}
        </button>
      </div>
      {res && (
        <div
          className="rf-example"
          style={{ marginTop: 8, padding: 8, fontSize: "var(--fs-sm)" }}
        >
          {res.terms.length > 0 ? (
            <div>
              <span className="mt-muted">сработало: </span>
              {res.terms.map((t, i) => (
                <b key={i}>
                  {t.surface} → {t.output_abbreviation ?? t.target_text}
                  {i < res.terms.length - 1 ? "; " : ""}
                </b>
              ))}
            </div>
          ) : (
            <div className="mt-muted">термины не сматчились</div>
          )}
          {res.translation && (
            <div style={{ marginTop: 4, overflowWrap: "anywhere" }}>
              <span className="mt-muted">перевод: </span>
              <b>{res.translation}</b>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
